/**
 * Individualization Request.
 *
 *
 * @beta
 */
export const INDIVIDUALIZATION_REQUEST = 'individualization-request'
